package com.shadowings.gero.data.lessons.chapter14

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.data.lessons.buildAdverbialSentenceSync
import com.shadowings.gero.data.lessons.buildImperfectiveSentenceSync
import com.shadowings.gero.data.lessons.distinctBaseWordCount
import com.shadowings.gero.data.lessons.chapter11.buildRichestPseudoverbalSentence
import com.shadowings.gero.data.lessons.chapter11.buildWordBankFromWords
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import kotlin.random.Random
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_la_particella_ni_1
import gero.composeapp.generated.resources.exp_content_la_particella_ni_10
import gero.composeapp.generated.resources.exp_content_la_particella_ni_11
import gero.composeapp.generated.resources.exp_content_la_particella_ni_12
import gero.composeapp.generated.resources.exp_content_la_particella_ni_13
import gero.composeapp.generated.resources.exp_content_la_particella_ni_14
import gero.composeapp.generated.resources.exp_content_la_particella_ni_2
import gero.composeapp.generated.resources.exp_content_la_particella_ni_3
import gero.composeapp.generated.resources.exp_content_la_particella_ni_4
import gero.composeapp.generated.resources.exp_content_la_particella_ni_5
import gero.composeapp.generated.resources.exp_content_la_particella_ni_6
import gero.composeapp.generated.resources.exp_content_la_particella_ni_7
import gero.composeapp.generated.resources.exp_content_la_particella_ni_8
import gero.composeapp.generated.resources.exp_content_la_particella_ni_9
import gero.composeapp.generated.resources.exp_title_la_particella_ni

fun getLaParticellaNiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_2,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_4,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "D35-U2:D4-A1-W19-X1:Z4-O34:D21-G43-Q3:N35",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_5,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "D35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_6,
            face = Faces.Surprised,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "D35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_7,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "D35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_8,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_9,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_10,
            face = Faces.Idle,
            character = Characters.Alyn
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_11,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_12,
            face = Faces.Idle,
            character = Characters.Alyn
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_13,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_particella_ni,
            content = Res.string.exp_content_la_particella_ni_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

private data class GeneratedSentence(
    val hieroglyphs: String,
    val transliteration: String,
    val translation: String,
    val isNegative: Boolean
)

private enum class QuizTypeKind {
    WORD_BANK,
    TEXT_TRANSLATION,
    PHONETIC_KEYBOARD
}

fun getLaParticellaNiQuizContent(
    hiero: List<Hiero> = emptyList(),
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String = "",
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val effectiveWords = words.ifEmpty { DatabaseRepositoryImpl.words }
    val effectiveVerbs = verbs.ifEmpty { DatabaseRepositoryImpl.verbs }
    val effectiveVerbSentences = verbSentences.ifEmpty { DatabaseRepositoryImpl.verbSentences }
    val effectiveAdverbials = DatabaseRepositoryImpl.adverbialSentences
    val pool = effectiveVerbSentences.filter { it.verbs.isNotEmpty() }
        .ifEmpty { DatabaseRepositoryImpl.verbSentences.filter { it.verbs.isNotEmpty() } }

    if (effectiveWords.isEmpty() || effectiveVerbs.isEmpty() || effectiveVerbSentences.isEmpty() || effectiveAdverbials.isEmpty() || pool.isEmpty()) {
        return emptyList()
    }

    // 10 total questions: 3 VSO, 3 Adverbial, 4 Pseudoverbal.
    // 50:50 negative ratio: exactly 5 negative and 5 positive.
    val vsoNegCount = if (random.nextBoolean()) 2 else 1
    val advNegCount = 3 - vsoNegCount

    val vsoNegFlags = (List(vsoNegCount) { true } + List(3 - vsoNegCount) { false }).shuffled(random)
    val advNegFlags = (List(advNegCount) { true } + List(3 - advNegCount) { false }).shuffled(random)
    val pseudoNegFlags = listOf(true, true, false, false).shuffled(random)

    val seenTranslations = mutableSetOf<String>()

    // 1) 3 VSO sentences with random complements (objects 0, 1, 2)
    val vsoSentences = mutableListOf<GeneratedSentence>()
    for (isNeg in vsoNegFlags) {
        var chosen: GeneratedSentence? = null
        for (attempt in 0 until 10) {
            val candidateSoggetti = if (random.nextBoolean() && effectiveVerbSentences.any { distinctBaseWordCount(it.subjects, effectiveWords) >= 2 }) 2 else 1
            val candidateRows = effectiveVerbSentences.filter { distinctBaseWordCount(it.subjects, effectiveWords) >= candidateSoggetti }
            val maxObjects = candidateRows.maxOfOrNull { distinctBaseWordCount(it.objects, effectiveWords) } ?: 0
            val possibleOggetti = (0..minOf(2, maxObjects)).toList().ifEmpty { listOf(0) }
            val candidateOggetti = possibleOggetti.random(random)

            val res = buildImperfectiveSentenceSync(
                soggettiCount = candidateSoggetti,
                oggettiCount = candidateOggetti,
                random = random,
                verbSentences = effectiveVerbSentences,
                words = effectiveWords,
                verbs = effectiveVerbs,
                isNegative = isNeg
            )
            val translation = when (languageCode) {
                "it" -> res.translationIt
                "de" -> res.translationDe
                "es" -> res.translationEs
                "fr" -> res.translationFr
                else -> res.translationEn
            }
            val item = GeneratedSentence(res.hieroglyphs, res.transliteration, translation, isNeg)
            if (translation !in seenTranslations || attempt == 9) {
                seenTranslations.add(translation)
                chosen = item
                break
            }
        }
        chosen?.let { vsoSentences.add(it) }
    }

    // 2) 3 Adverbial sentences with random locative complement / place
    val advSentences = mutableListOf<GeneratedSentence>()
    for (isNeg in advNegFlags) {
        var chosen: GeneratedSentence? = null
        for (attempt in 0 until 10) {
            val maxAdvSubjects = effectiveAdverbials.maxOfOrNull { it.subjects.size } ?: 1
            val soggettiCount = if (maxAdvSubjects >= 2 && random.nextBoolean()) 2 else 1
            val res = buildAdverbialSentenceSync(
                soggettiCount = soggettiCount,
                withParticleIw = true,
                random = random,
                words = effectiveWords,
                adverbialSentences = effectiveAdverbials,
                isNegative = isNeg
            )
            val translation = when (languageCode) {
                "it" -> res.translationIt
                "de" -> res.translationDe
                "es" -> res.translationEs
                "fr" -> res.translationFr
                else -> res.translationEn
            }
            val item = GeneratedSentence(res.hieroglyphs, res.transliteration, translation, isNeg)
            if (translation !in seenTranslations || attempt == 9) {
                seenTranslations.add(translation)
                chosen = item
                break
            }
        }
        chosen?.let { advSentences.add(it) }
    }

    // 3) 4 Pseudoverbal sentences with random complements (bare, direct object, or complex object with possessor)
    val pseudoSentences = mutableListOf<GeneratedSentence>()
    for (isNeg in pseudoNegFlags) {
        var chosen: GeneratedSentence? = null
        for (attempt in 0 until 10) {
            val isPronominal = random.nextBoolean()
            val res = buildRichestPseudoverbalSentence(
                pool = pool,
                verbs = effectiveVerbs,
                words = effectiveWords,
                isPronominal = isPronominal,
                languageCode = languageCode,
                random = random,
                isNegative = isNeg
            )
            val item = GeneratedSentence(res.hieroglyphs, res.transliteration, res.translation, isNeg)
            if (res.translation !in seenTranslations || attempt == 9) {
                seenTranslations.add(res.translation)
                chosen = item
                break
            }
        }
        chosen?.let { pseudoSentences.add(it) }
    }

    val allSentences = (vsoSentences + advSentences + pseudoSentences).shuffled(random)

    // Quiz types: exactly 1 PhoneticKeyboardContent, 5 WordSelectionContent, 4 TextTranslationContent
    val quizTypes = (listOf(QuizTypeKind.PHONETIC_KEYBOARD) +
        List(5) { QuizTypeKind.WORD_BANK } +
        List(4) { QuizTypeKind.TEXT_TRANSLATION }).shuffled(random)

    return allSentences.zip(quizTypes).map { (sentence, type) ->
        when (type) {
            QuizTypeKind.PHONETIC_KEYBOARD -> {
                PhoneticKeyboardContent(
                    sentence = sentence.hieroglyphs,
                    info = "${sentence.transliteration} -> ${sentence.translation}",
                    reading = sentence.transliteration.map { it.toString() },
                    isProperName = false,
                    canRotate = false
                )
            }
            QuizTypeKind.TEXT_TRANSLATION -> {
                TextTranslationContent(
                    hieroglyphs = sentence.hieroglyphs,
                    correctPhrase = sentence.translation,
                    transliteration = sentence.transliteration
                )
            }
            QuizTypeKind.WORD_BANK -> {
                val baseBank = buildWordBankFromWords(
                    correctPhrase = sentence.translation,
                    words = effectiveWords,
                    verbs = effectiveVerbs,
                    languageCode = languageCode,
                    random = random
                )
                val wordBank = if (!sentence.isNegative) {
                    val negDistractors = when (languageCode) {
                        "it" -> listOf("non")
                        "de" -> listOf("nicht")
                        "es" -> listOf("no")
                        "fr" -> listOf("ne", "pas")
                        else -> listOf("not")
                    }
                    (baseBank + negDistractors).shuffled(random)
                } else {
                    baseBank
                }
                WordSelectionContent(
                    hieroglyphs = sentence.hieroglyphs,
                    correctPhrase = sentence.translation,
                    words = wordBank,
                    transliteration = sentence.transliteration
                )
            }
        }
    }
}
